(function () {
  'use strict';

  if (!window.customElements || window.customElements.get('variant-option-select')) return;

  // Variant picker > Picker style > Dropdowns (snippets/product-option-select.liquid).
  // The option's buttons stay in the same group, hidden, and remain the selection's source of truth:
  // choosing a value clicks its button, so product.js, featured-product.js and the quick view run
  // their own variant logic unchanged. Those controllers mark the active and sold out values on the
  // buttons' classes, and the dropdown mirrors them.
  class VariantOptionSelect extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.group = this.parentElement;
      if (!this.select || !this.group) return;
      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();
      this.select.addEventListener('change', this.handleChange.bind(this), { signal: this.abortController.signal });
      // A combined listing value of another product leaves the page; coming Back from the browser's
      // cache shows the buttons' selection again instead of the value that was chosen.
      window.addEventListener('pageshow', (function (event) {
        if (event.persisted) this.sync();
      }).bind(this), { signal: this.abortController.signal });
      if (this.observer) this.observer.disconnect();
      this.observer = new MutationObserver(this.sync.bind(this));
      this.observer.observe(this.group, { subtree: true, attributes: true, attributeFilter: ['class'] });
      this.sync();
    }

    disconnectedCallback() {
      if (this.abortController) this.abortController.abort();
      if (this.observer) this.observer.disconnect();
      this.abortController = null;
      this.observer = null;
    }

    buttons() {
      return Array.prototype.slice.call(this.group.querySelectorAll('button[data-option-value-id]'));
    }

    handleChange() {
      var valueId = this.select.value;
      var button = this.buttons().find(function (item) {
        return item.dataset.optionValueId === valueId;
      });
      if (button && !button.classList.contains('active')) button.click();
    }

    sync() {
      var template = this.dataset.soldOutTemplate || '[value]';
      var buttonsById = new Map();
      this.buttons().forEach(function (button) {
        buttonsById.set(button.dataset.optionValueId, button);
      });
      var activeValueId = '';
      Array.prototype.forEach.call(this.select.options, function (option) {
        var button = buttonsById.get(option.value);
        if (!button) return;
        var label = button.dataset.value || '';
        var text = button.classList.contains('unavailable') ? template.replace('[value]', label) : label;
        if (option.textContent !== text) option.textContent = text;
        if (button.classList.contains('active')) activeValueId = option.value;
      });
      if (activeValueId && this.select.value !== activeValueId) this.select.value = activeValueId;
    }
  }

  window.customElements.define('variant-option-select', VariantOptionSelect);
})();
